import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'components/Dropdown2';

import './RatingsInstructorFilter.scss';

const messages = defineMessages({
  label: {
    id: 'ratings.instructor-filter.label',
    defaultMessage: 'Staff',
  },
  allInstructors: {
    id: 'ratings.instructor-filter.all-instructors',
    defaultMessage: 'All Staff',
  },
});

const RatingsInstructorFilter = ({ instructors, selectedInstructorId, updateInstructor, isVenueFoodAndBeverage }) => {
  const intl = useIntl();

  if (!instructors.length || isVenueFoodAndBeverage) {
    return null;
  }

  const options = [
    {
      label: intl.formatMessage(messages.allInstructors),
      value: null,
      match: '',
      isFilterable: false,
    },
    ...instructors.map(({ id, name }) => ({
      label: name,
      value: id,
      match: `${id} ${name}`,
    })),
  ];
  const selectedOption = options.find(({ value }) => value === selectedInstructorId);

  return (
    <Dropdown
      autocomplete
      options={options}
      selectedOption={selectedOption || {}}
      dataCypress="ratings-instructor-filter">
      <DropdownToggle label={messages.label} />
      <DropdownMenu>
        {data =>
          data.map(({ option, isHighlighted, ref }) => {
            const { label, value } = option;
            return (
              <DropdownItem
                key={value}
                ref={ref}
                isSelected={value === selectedInstructorId}
                isHighlighted={isHighlighted}
                onClick={() => updateInstructor(value)}>
                {label}
              </DropdownItem>
            );
          })
        }
      </DropdownMenu>
    </Dropdown>
  );
};

RatingsInstructorFilter.propTypes = {
  instructors: PropTypes.arrayOf(
    PropTypes.shape({
      instructorId: PropTypes.number,
      instructorName: PropTypes.string,
    })
  ),
  updateInstructor: PropTypes.func,
  selectedInstructorId: PropTypes.number,
  isVenueFoodAndBeverage: PropTypes.bool,
};

export default RatingsInstructorFilter;
